import TagManager from 'react-gtm-module';
import getConfig from 'next/config';
import { useEffect } from 'react';

export const useGoogleTagManager = () => {
  const { publicRuntimeConfig } = getConfig();

  useEffect(() => {
    TagManager.initialize({
      gtmId: publicRuntimeConfig?.googleTagManagerId,
      // preview: publicRuntimeConfig?.environment, // to set environments
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {};
};
